import {kSystemIcons} from "../../../constants/icons";

export default function AuthenticationLockIcon() {
    // Used in AuthenticationPasswordInput to display icon
    // that make password visible

    // BUILD
    return (
        <i className={`material-icons text-[16px] text-greyLight9`}>
            {kSystemIcons.lock}
        </i>
    );
}